import React, { useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { push as Push, replace as Replace } from 'redux-first-history';
import { ManagePrivateIPs as SettingsModule } from '@dev/ee-modules';

import { ApplicationState as State } from '@api/store';
import Props from './PrivateIPInterface';
import { ShowDialog } from '@api/store/dialog/actions';
import { ShowDialogParams } from '@api/store/dialog/types';
import { LoadPools, DeletePurchaseInfo, AddPurchaseInfo, LoadAllIPs, MoveIPToPool } from '@api/store/pools/actions';
import { PurchasePrivateIP } from '@api/store/account/actions';
import { BillingPaths, LegacyPaths, SettingsPaths } from '@api/services/dictionaries/paths';
import { PurchaseInfo } from '@api/store/pools/types';

import { addParamToUrl } from '@api/services/tools/handleUrlParams';
import { ProductCode } from '@dev/ee-api/ee-api-models';
import { getProviders, LoadPaymentProviders } from '@api/store/payments/actions';

const mapState = (state: State, ownProps: Props): Props => {
    return {
        ...ownProps,
        account: state.account,
        browser: state.browser,
        dialog: state.dialog,
        pools: state.pools,
        config: state.config,
        payments: state.payments,
    };
};
const dispatchProps = {
    ShowDialog,
    LoadPools,
    AddPurchaseInfo,
    DeletePurchaseInfo,
    PurchasePrivateIP,
    LoadAllIPs,
    MoveIPToPool,
    Push,
    Replace,
};
interface DispatchProps {
    ShowDialog(params: ShowDialogParams): void;
    LoadPools(): void;
    AddPurchaseInfo(purchaseInfo: PurchaseInfo): void;
    DeletePurchaseInfo(): void;
    LoadAllIPs(): void;
    MoveIPToPool(oldPool: string, newPool: string): void;
    PurchasePrivateIP(purchaseInfo: { region?: string; quantity?: number }): void;
    Push(url: string): void;
    Replace(url: Record<string, string>): void;
}

type ExtendedProps = Props & DispatchProps;

const ManagePrivateIPs = (props: ExtendedProps) => {
    const dispatch = useDispatch();
    const providers = useSelector(getProviders);

    useEffect(() => {
        if (!providers) dispatch(LoadPaymentProviders());
    }, []);

    const setUrlParams = (param: Record<string, any>): void => {
        const { Replace } = props;
        const url = addParamToUrl(param);
        Replace({ search: url });
    };

    const buyIpLegacy = () => {
        if (props?.config?.bootedAsChild) {
            window.location.replace(`${location.origin}${LegacyPaths.BuyLegacyIp}`);
            return;
        }
        props.Push(LegacyPaths.BuyLegacyIp);
    };

    const { isStandalone, bootedAsChild } = props?.config || {};
    return (
        <SettingsModule
            BuyIp={(isStandalone || bootedAsChild) && buyIpLegacy.bind(this)}
            retriveUrlParamsToAdd={setUrlParams.bind(this)}
            paths={{ ...SettingsPaths, ...BillingPaths }}
            productCode={ProductCode.EmailApi}
            {...props}
        />
    );
};

export default connect<Props, DispatchProps>(mapState, dispatchProps)(ManagePrivateIPs);
